<template>
	<div class="ReDistrictMultiPicker">
		
		<div >
			<!-- <div class="d-flex iframe-button pt-1"><base-button @click="hideDistricts()" type="danger" class="" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button></div> -->
			<div class="inline-flex mb-2 ">
				<base-button @click="loadDistricts()" v-if="switchBtn==false" type="primary" class="mt-0 w-100" simple>Выбор районов</base-button>
				<base-button @click="hideDistricts()" v-if="switchBtn==true" type="primary" class="mt-0 w-100" simple >{{ btnText }}: {{ bufferValue.length }}</base-button>
			</div>

			<div v-if="bIsShown">
				<tabs type="primary" 
					:activeTab="currentTab"
					@change="OnTabChange"
					tabContentClasses="tab-opt"
					inline
					round	
					class="card card-plain mb-0 ">
					<tab-pane v-for="reg in regionList" :key="reg.id" :id="String(reg.id)" :label="reg.name">
						<template  v-if="reg.id==currentTab && ApiData">
							<div style="display: flex;">
								<!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll_spb" @change="handleCheckAllChange_spb" class="mb-3">Выбрать всё</el-checkbox>-->
								<el-checkbox-group v-model="bufferValue">
									<el-checkbox v-for="distr in ApiData" :label="distr.id" :key="String(distr.id)">{{ distr.cellName }}</el-checkbox>
								</el-checkbox-group>

								<!--
									<div class="checkbox-radios-col">
										<el-checkbox v-for="(el_opt, el_index) in ApiData" :key="el_opt.id+'_'+el_index" :name="String(el_opt.id)" 
										v-model="bufferValue" :value="el_opt" inline>{{el_opt.cellName}}</el-checkbox>
									</div>
								-->
							</div>
						</template>
					</tab-pane>
				</tabs>
			</div>
			<!-- <base-input type="hidden" v-model="bufferValue"></base-input> -->
		</div>
	<!-- <pre>ApiData.length	{{ ApiData.length }} </pre> -->	<!-- <pre>	{{ ApiData }} </pre> -->
		
		
	</div>
</template>

<script>
	import { Select, Option, CheckboxGroup, Checkbox, RadioGroup, Radio  } from 'element-ui';
	import { TabPane, Tabs } from 'src/components';
	// import { BaseRadio } from 'src/components/index';

	export default {
		name: 'ReDistrictMultiPicker',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			[Checkbox.name]: Checkbox, 
			[CheckboxGroup.name]: CheckboxGroup,
			[Radio.name]: Radio, 
			[RadioGroup.name]: RadioGroup,
			TabPane,
			Tabs,
			// BaseRadio,
		},
		props: {
			value: [Array ],
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			regions: [Array],
			// value: {
			// 	type: Object,
			// 	default() {	return {'distr_id':''}; }
			// },
		},
		data () {
			return {
				ver: 1,
				fullscreenLoading: false,
				bIsShown:false,
				switchBtn:false,
				btnText: 'Выбор районов', 
				currentTab:'',
				// distrTab: '78',
				ApiData:[],
				// checkedDistricts_spb: [],
				// checkedDistricts_lo:[],
				// checkedDistricts_ka:[],
				// checkAll_spb: false,
				// checkAll_lo: false,
				// checkAll_ka: false,
				// isIndeterminate: false,
				bufferValue: [],
				regionList:[],
			}
		},
		watch:{
			value(val){
				// console.log('val',val);
				this.bufferValue = val || [];
				// console.log(this.value,'value');
			},
			bufferValue(val){
				// console.log('buffer', val);
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
				this.$emit('bufferValueDistr', this.bufferValue);
				// this.$emit('checked', JSON.stringify(this.bufferValue));
				// console.log(this.bufferValue,'bufferValue');
			},
			
		},
		computed: {
			
		},
		methods: {
			
			loadDistricts(){
				this.bIsShown = true;
				this.switchBtn = true;
				// console.log('this.bIsShown', this.bIsShown);
				// if(this.bIsShown == true){
				// 	this.btnText = 'Скрыть районы';
				// } else {this.btnText = 'Выбор районов';}
				// this.getApiData('78');
			},
			hideDistricts(){
				this.bIsShown = !this.bIsShown;
				// console.log('this.bIsShown', this.bIsShown);
				if(this.bIsShown == true){
					this.btnText = 'Скрыть районы';
				} else {this.btnText = 'Выбор районов';}
				
			},
			OnTabChange(strTabId){
				// console.log(strTabId)
				if(this.currentTab == strTabId) return true;
				this.currentTab = strTabId;
				this.getApiData(strTabId);
			},
			getApiData(region){
				// let filter = {list:true};
				this.ApiData=[];

				this.$GVO.Api.cat_districts.GET({flt:{/*...filter, */region:region, act:'1'}})
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.ApiData = objApi.data;
							if(this.value!='')this.bufferValue = this.value;
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
				
			},
			async RegionLoad(){
				const obj = await this.$GVO.Api.cat_districts.GET_DISTRINCT_REGIONS({flt:{regions: this.regions}});
				if(obj.success === true && obj.data.length>0){
					this.regionList = obj.data;
					if(this.regionList.find(r=>r.id==78))
						this.currentTab='78';
					else this.currentTab=this.regionList[0].id;
					this.getApiData(this.currentTab);
				}
			}
	
		},
		mounted() {
			this.RegionLoad();
		}
	}
</script>
<style scoped>

.ReDistrictMultiPicker >>> .nav-pills .nav-item .nav-link {padding: 0px 20px; min-width: 74px;} 
.ReDistrictMultiPicker >>> .tab-content {padding-top: 0px;}

.card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
}
.ReDistrictMultiPicker .el-checkbox-group,
.ReDistrictMultiPicker .el-radio-group {
    display: flex;
    flex-direction: column;
	width: 49%;
}
.ReDistrictMultiPicker .checkbox-radios-col {
	display: flex;
    flex-direction: column;
}
.white-content .card:not(.card-white) >>> label {
		color: #1d253b!important;
	}
/*===media===============================*/
@media (max-width: 768px) {
	/* .flat .row {width: 100%; margin-left: 0px;} */
}

</style>
